import { Jackpot, createBlockJackpotMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockJackpotModel = ConfirmModalModel<Jackpot, number, Jackpot>;

export const createBlockJackpotModel = (): BlockJackpotModel => {
	const blockJackpotMutation = createBlockJackpotMutation();

	const model = createConfirmModalModel<Jackpot, number, Jackpot>({
		modalData: declareModalData<Jackpot>(),
		mapModalData: ({ id }) => id,
		mutation: blockJackpotMutation,
		successMessageKey: 'block-jackpot.success',
	});

	return model;
};
